import { BaseEnumResolver, BaseEnumResolverProps } from "./BaseEnumResolver";
export const DigitalIdentityTypeResolver = (props: Omit<BaseEnumResolverProps, "type">) => {
  return <BaseEnumResolver {...props} options={[{
    value: "CITIZEN",
    label: "Citizen"
  }, {
    value: "LEGAL_ENTITY",
    label: "Legal Entity"
  }]} useToggleForTwoOptions data-sentry-element="BaseEnumResolver" data-sentry-component="DigitalIdentityTypeResolver" data-sentry-source-file="DigitalIdentityTypeResolver.tsx" />;
};